export const skillsLine = [
    "/skills/html.png",
    "/skills/css.png",
    "/skills/sass.png",
    "/skills/bootstrap.png",
    "/skills/tailwindcss.png",
    "/skills/js.png",
    "/skills/typescript.png",
    "/skills/react.png",
    "/skills/redux.png",
    "/skills/nextjs.png",
    "/skills/graphql.png",
    "/skills/nodejs.png",
    "/skills/nestjs.png",
    "/skills/mongodb.png",
    "/skills/postgresql.png",
    "/skills/webpack.png",
    "/skills/gulp.png",
    "/skills/git.png",
];
